import {
  ActionType,
  CategoryFieldType,
  ClusterTypes,
  ConditionType,
  DeliveryStatus,
  DeliveryType,
  EntityType,
  FieldType,
  Group,
  LegalEntityType,
  OrderStatus,
  PaymentMethod,
  PaymentStatus,
  PriceDocumentType,
  RuleType,
  Status,
  TaskStatus,
  TaskType,
  Unit,
  ValueType,
} from '../../types/enums'

export const orderTypeToText = (value: string | number): string => {
  switch (value) {
    case Group.SLOT:
      return 'Слот'
    case Group.TRANSPORT:
      return 'Транспорт'
    case Group.CARGO:
      return 'Груз'
    default:
      return 'Текст не найден'
  }
}

export const orderStatusToText = (value: number): string => {
  switch (value) {
    case Status.ARCHIVED:
      return 'В архиве'
    case Status.CANCELED:
      return 'Отменен'
    case Status.DELETED:
      return 'Удален'
    case Status.DISRUPTED:
      return 'Сорван'
    case Status.COMPLETED:
      return 'Завершен'
    case Status.IN_WORK:
      return 'В работе'
    case Status.NEW:
      return 'Новый'
    case Status.POSTPONED:
      return 'Отложен'
    default:
      return 'Статус не найден'
  }
}
export const clusterTypeToText = (value: ClusterTypes): string => {
  switch (value) {
    case ClusterTypes.CLOTHES:
      return 'Одежда'
    case ClusterTypes.FOOD:
      return 'Готовая еда, ресторан и/или доставка'
    case ClusterTypes.DIY:
      return 'Дом и ремонт'
    case ClusterTypes.FLOWERS:
      return 'Цветы'
    case ClusterTypes.FURNITURE:
      return 'Мебель'
    case ClusterTypes.DOORS:
      return 'Двери'
    case ClusterTypes.DEALER:
      return 'Автосалон'
    case ClusterTypes.OIL:
      return 'Масла, технические жидкости'
    case ClusterTypes.COSMETICS:
      return 'Косметика, парфюмерия'
    case ClusterTypes.BEAUTY_SALON:
      return 'Салон красоты'
    case ClusterTypes.MEDICINE:
      return 'Медицина'
    case ClusterTypes.PHOTO_STUDIO:
      return 'Фотостудия'
    case ClusterTypes.AUTO_PARTS:
      return 'Автозапчасти'
    default:
      return 'Тип не найден'
  }
}
export const fieldTypeToText = (value: FieldType): string => {
  switch (value) {
    case FieldType.NOT_SELECTED:
      return 'Тип поля'
    case FieldType.INPUT:
      return 'Текст'
    case FieldType.SELECT:
      return 'Выпадающий список'
    case FieldType.MULTISELECT:
      return 'Множественный выбор'
    case FieldType.CHECKBOX:
      return 'Переключатель'

    default:
      return 'Тип не найден'
  }
}
export const valueTypeToText = (value: ValueType): string => {
  switch (value) {
    case ValueType.NOT_SELECTED:
      return 'Тип значения'
    case ValueType.STRING:
      return 'Текст'
    case ValueType.NUMBER:
      return 'Число'
    case ValueType.DATE:
      return 'Дата'
    case ValueType.BOOLEAN:
      return 'Переключатель, истина или ложь'

    default:
      return 'Тип не найден'
  }
}

export const valueTypeToInputType = (value: ValueType): string => {
  switch (value) {
    case ValueType.STRING:
      return 'text'
    case ValueType.NUMBER:
      return 'text'
    case ValueType.DATE:
      return 'date'
    default:
      return 'unset'
  }
}
export const unitTypeToText = (value: Unit): string => {
  switch (value) {
    case Unit.NOT_SELECTED:
      return 'Единица измерения'
    case Unit.CENTIMETER:
      return 'сантиметр'
    case Unit.MILLILITER:
      return 'миллилитр'
    case Unit.GRAM:
      return 'грамм'
    case Unit.KILOGRAM:
      return 'килограмм'
    case Unit.METER:
      return 'метр'
    case Unit.LITER:
      return 'литр'
    case Unit.PIECE:
      return 'штука'
    case Unit.TON:
      return 'тонна'
    case Unit.MINUTE:
      return 'минута'
    case Unit.HOUR:
      return 'час'
    case Unit.DAY:
      return 'день'
    case Unit.MONTH:
      return 'месяц'
    case Unit.YEAR:
      return 'год'
    case Unit.PORTION:
      return 'порция'
    case Unit.EMPTY:
      return ''
    default:
      return 'Тип не найден'
  }
}

export const unitTypeToShort = (value: Unit): string => {
  switch (value) {
    case Unit.GRAM:
      return 'г'
    case Unit.KILOGRAM:
      return 'кг'
    case Unit.TON:
      return 'т'
    case Unit.MILLILITER:
      return 'мл'
    case Unit.LITER:
      return 'л'
    case Unit.PIECE:
      return 'шт'
    case Unit.CENTIMETER:
      return 'см'
    case Unit.METER:
      return 'м'
    case Unit.MINUTE:
      return 'мин'
    case Unit.HOUR:
      return 'ч'
    case Unit.DAY:
      return 'дн'
    case Unit.MONTH:
      return 'мес'
    case Unit.YEAR:
      return 'год'
    case Unit.PORTION:
      return 'порц'
    case Unit.EMPTY:
      return ''
    case Unit.NOT_SELECTED:
    default:
      return ''
  }
}

export const getDeliveryTypeText = (type: DeliveryType): string => {
  switch (Number(type)) {
    case Number(DeliveryType.DELIVERY):
      return 'Доставка'
    case Number(DeliveryType.PICKUP):
      return 'Самовывоз'
    default:
      return 'Неизвестно'
  }
}

export const getPaymentMethodText = (method: PaymentMethod): string => {
  switch (Number(method)) {
    case Number(PaymentMethod.CARD_ON_DELIVERY):
      return 'Картой'
    case Number(PaymentMethod.CASH_ON_DELIVERY):
      return 'Наличными'
    case Number(PaymentMethod.ONLINE):
      return 'Онлайн'
    default:
      return 'Неизвестно'
  }
}

export const getOrderStatusText = (status: OrderStatus): string => {
  switch (Number(status)) {
    case Number(OrderStatus.NEW):
      return 'Новый'
    case Number(OrderStatus.PREPARING):
      return 'Готовится'
    case Number(OrderStatus.DELIVERING):
      return 'Доставляется'
    case Number(OrderStatus.DELIVERED):
      return 'Доставлен'
    case Number(OrderStatus.READY):
      return 'Собран'
    case Number(OrderStatus.PICKED_UP):
      return 'Выдан при самовывозе'
    case Number(OrderStatus.CANCELLED):
      return 'Отменен'
    default:
      return 'Неизвестно'
  }
}

export const getPaymentStatusText = (status: PaymentStatus): string => {
  switch (Number(status)) {
    case Number(PaymentStatus.PENDING):
      return 'Ожидает оплаты'
    case Number(PaymentStatus.PAID):
      return 'Оплачен'
    case Number(PaymentStatus.FAILED):
      return 'Ошибка оплаты'
    case Number(PaymentStatus.REFUNDED):
      return 'Возврат'
    default:
      return 'Неизвестно'
  }
}

export const getOrderStatusColor = (status: OrderStatus): string => {
  switch (Number(status)) {
    case Number(OrderStatus.NEW):
      return '#3498db' // синий
    case Number(OrderStatus.PREPARING):
      return '#f39c12' // оранжевый
    case Number(OrderStatus.DELIVERING):
      return '#9b59b6' // фиолетовый
    case Number(OrderStatus.READY):
      return '#2ecc71' // зеленый (готов к выдаче)
    case Number(OrderStatus.DELIVERED):
      return '#27ae60' // темно-зеленый (доставлен)
    case Number(OrderStatus.PICKED_UP):
      return '#27ae60' // темно-зеленый (выдан)
    case Number(OrderStatus.CANCELLED):
      return '#e74c3c' // красный
    default:
      return '#95a5a6' // серый
  }
}

export const getPaymentStatusColor = (status: PaymentStatus): string => {
  switch (Number(status)) {
    case Number(PaymentStatus.PENDING):
      return '#f39c12' // оранжевый
    case Number(PaymentStatus.PAID):
      return '#2ecc71' // зеленый
    case Number(PaymentStatus.FAILED):
      return '#e74c3c' // красный
    case Number(PaymentStatus.REFUNDED):
      return '#95a5a6' // серый
    default:
      return '#95a5a6' // серый
  }
}

export const getRuleTypeText = (type: RuleType): string => {
  switch (type) {
    case RuleType.DISCOUNT:
      return 'Скидка'
    case RuleType.DELIVERY:
      return 'Доставка'
    case RuleType.BONUS:
      return 'Бонусы'
    case RuleType.PROMO_CODE:
      return 'Промокод'
    default:
      return 'Неизвестно'
  }
}

export const getConditionTypeText = (type: ConditionType): string => {
  switch (type) {
    case ConditionType.MIN_ORDER_AMOUNT:
      return 'Минимальная сумма заказа'
    case ConditionType.PROMO_CODE:
      return 'Промокод'
    case ConditionType.TIME_RANGE:
      return 'Временной интервал'
    case ConditionType.PRODUCT_IN_CATEGORY:
      return 'Товар в категории'
    case ConditionType.DAY_OF_WEEK:
      return 'День недели'
    default:
      return 'Неизвестно'
  }
}

export const getActionTypeText = (type: ActionType): string => {
  switch (type) {
    case ActionType.PERCENTAGE_DISCOUNT:
      return 'Процентная скидка'
    case ActionType.FIXED_DISCOUNT:
      return 'Фиксированная скидка'
    case ActionType.SET_DELIVERY_COST:
      return 'Установить стоимость доставки'
    case ActionType.FREE_DELIVERY:
      return 'Бесплатная доставка'
    case ActionType.ADD_BONUS_POINTS:
      return 'Добавить бонусы'
    case ActionType.USE_BONUS_POINTS:
      return 'Списать бонусы'
    default:
      return 'Неизвестно'
  }
}

// Для типа доставки
export const getDeliveryTypeColor = (type: DeliveryType): string => {
  switch (Number(type)) {
    case Number(DeliveryType.DELIVERY):
      return '#3498db' // синий
    case Number(DeliveryType.PICKUP):
      return '#2ecc71' // зеленый
    case Number(DeliveryType.UNSET):
      return '#95a5a6' // серый
    default:
      return '#95a5a6'
  }
}

// Для способа оплаты
export const getPaymentMethodColor = (method: PaymentMethod): string => {
  switch (Number(method)) {
    case Number(PaymentMethod.CARD_ON_DELIVERY):
      return '#9b59b6' // фиолетовый
    case Number(PaymentMethod.CASH_ON_DELIVERY):
      return '#f39c12' // оранжевый
    case Number(PaymentMethod.UNSET):
      return '#95a5a6' // серый
    default:
      return '#95a5a6'
  }
}

// common/utils/functions/enumToText.ts
export const legalEntityTypeToText = (type: LegalEntityType): string => {
  switch (type) {
    case LegalEntityType.UNSET:
      return 'Не выбрано'
    case LegalEntityType.INDIVIDUAL:
      return 'ИП'
    case LegalEntityType.LLC:
      return 'ООО'
    case LegalEntityType.JSC:
      return 'АО'
    case LegalEntityType.SOLE:
      return 'Самозанятый'
    case LegalEntityType.OTHER:
      return 'Другое'
    default:
      return 'Не выбрано'
  }
}

export const getPriceDocumentTypeText = (type: PriceDocumentType) => {
  switch (type) {
    case PriceDocumentType.INIT:
      return 'Инициализация'
    case PriceDocumentType.SYNC:
      return 'Синхронизация'
    case PriceDocumentType.MANUAL:
      return 'Ручное изменение'
    case PriceDocumentType.IMPORT:
      return 'Импорт'
    case PriceDocumentType.CALCULATION:
      return 'Пересчет'
    default:
      return 'Документ'
  }
}

export const getStockDocumentTypeText = (type: number) => {
  switch (type) {
    case 0:
      return 'Приход'
    case 1:
      return 'Списание'
    default:
      return 'Документ'
  }
}

export const categoryFieldTypeToText = (type: CategoryFieldType | number): string => {
  switch (type) {
    case CategoryFieldType.STRING:
      return 'Строка'
    case CategoryFieldType.NUMBER:
      return 'Число'
    case CategoryFieldType.TEXT:
      return 'Текст'
    case CategoryFieldType.DATE:
      return 'Дата'
    case CategoryFieldType.BOOLEAN:
      return 'Да/Нет'
    default:
      return '—'
  }
}

export const getDeliveryStatusText = (status?: DeliveryStatus): string => {
  if (!status) return 'Обрабатывается'

  const statusMap: Record<DeliveryStatus, string> = {
    [DeliveryStatus.CREATED]: 'Создан',
    [DeliveryStatus.IN_TRANSIT]: 'В пути',
    [DeliveryStatus.READY_FOR_PICKUP]: 'Готов к выдаче',
    [DeliveryStatus.DELIVERED]: 'Доставлен',
    [DeliveryStatus.NOT_DELIVERED]: 'Не доставлен',
    [DeliveryStatus.RETURNED]: 'Возвращён',
    [DeliveryStatus.CANCELLED]: 'Отменён',
  }

  return statusMap[status] || status
}

// common/utils/functions/enumToText.ts

export const entityTypeToText = (type: EntityType): string => {
  const map: Record<EntityType, string> = {
    [EntityType.CLUSTER]: 'Кластер',
    [EntityType.STORE]: 'Точка',
    [EntityType.CATEGORY]: 'Категория',
    [EntityType.ITEM]: 'Товар',
    [EntityType.EXECUTOR]: 'Исполнитель',
    [EntityType.MOTIVATION]: 'Мотивация',
    [EntityType.PLACE]: 'Место',
    [EntityType.BOOKING]: 'Бронирование',
    [EntityType.ORDER]: 'Заказ',
    [EntityType.COMPLEX_ORDER]: 'Комплексный заказ',
    [EntityType.PROMO]: 'Промо',
    [EntityType.STOCK]: 'Склад',
    [EntityType.PRICE]: 'Цена',
    [EntityType.STOCK_DOCUMENT]: 'Документ склада',
    [EntityType.PRICE_DOCUMENT]: 'Документ цены',
  }
  return map[type] ?? '—'
}

export const getTaskStatusText = (status: TaskStatus): string => {
  switch (status) {
    case TaskStatus.PENDING:
      return 'Ожидает'
    case TaskStatus.TAKEN:
      return 'Взят'
    case TaskStatus.IN_PROGRESS:
      return 'В пути'
    case TaskStatus.ARRIVED:
      return 'Прибыл'
    case TaskStatus.DELIVERED:
      return 'Доставлен'
    case TaskStatus.CANCELLED:
      return 'Отменён'
    default:
      return '—'
  }
}

export const getTaskTypeText = (type: TaskType): string => {
  switch (type) {
    case TaskType.DELIVERY:
      return 'Доставка'
    case TaskType.SALE:
      return 'Продажа'
    case TaskType.SERVICE:
      return 'Услуга'
    default:
      return '—'
  }
}

export const getTaskStatusColor = (status: TaskStatus): string => {
  switch (status) {
    case TaskStatus.PENDING:
      return '#F59E0B' // жёлтый
    case TaskStatus.TAKEN:
      return '#3B82F6' // синий
    case TaskStatus.IN_PROGRESS:
      return '#8B5CF6' // фиолетовый
    case TaskStatus.ARRIVED:
      return '#06B6D4' // циан
    case TaskStatus.DELIVERED:
      return '#10B981' // зелёный
    case TaskStatus.CANCELLED:
      return '#EF4444' // красный
    default:
      return '#9CA3AF'
  }
}
